import React from 'react';
import './App.css';
import {Routes, Route, Navigate} from 'react-router-dom';
import ProtoUI from "./pages/ProtoUI";
import Footer from "./components/footer";
import Header from "./components/header";
import ModalContent from "./components/modalContent";
import Proto2 from "./pages/Proto2";
import OpenAIChat from "./pages/OpenAIChat";

function App() {
    const [isPopupOpen, setIsPopupOpen] = React.useState(false);

    return (
        <>
        <ModalContent isPopupOpen={isPopupOpen} setIsPopupOpen={setIsPopupOpen} isNested={true}/>
        <Header />
        <Routes>
            <Route
                key={`route-0`}
                path={'/'}
                element={(<ProtoUI onClickOpenPopup={() => {setIsPopupOpen(true)}}/>)}
            />
            {process.env.REACT_APP_IS_DEV === 'true' ?
                <>
                    <Route
                        key={`route-0`}
                        path={'/prototype'}
                        element={(<Proto2 />)}
                    />
                    <Route
                        key={`route-0`}
                        path={'/chatter'}
                        element={(<OpenAIChat />)}
                    />
                </>
                : null
            }
            <Route key={`route-1`} path={'*'} element={(<Navigate to={"/"} />)} />
        </Routes>
        <Footer />
        </>
    );
}

export default App;
